import { render, staticRenderFns } from "./SoftwareStatistics.vue?vue&type=template&id=701ae747&scoped=true"
import script from "./SoftwareStatistics.vue?vue&type=script&lang=js"
export * from "./SoftwareStatistics.vue?vue&type=script&lang=js"
import style0 from "./SoftwareStatistics.vue?vue&type=style&index=0&id=701ae747&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701ae747",
  null
  
)

export default component.exports